import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { BreadCrumbService } from './breadcrumb.service';
import { BreadCrumbModel } from './breadcrumb.model';
import { ChipsService } from '../chips/chips.service';

@Component({
  selector: 'app-breadcrumb',
  styleUrls: ['./breadcrumb.component.scss'],
  templateUrl: './breadcrumb.component.html'
})

export class BreadcrumbComponent implements OnInit {
  private breadCrumbs: BreadCrumbModel[];
  public isBreadCrumbAvailable: boolean=false;
  private emailStatus: any = null;
  private emailAlert: boolean = false;

  constructor(
    private chipsService: ChipsService,
    protected router: Router,
    private breadCrumbService: BreadCrumbService) {
  }
  ngOnInit() {
    this.breadCrumbService.getCurrentBreadCrumb().subscribe((response) => {
      if (response) {
        this.emailStatus = sessionStorage.getItem('emailStatus');
        if (this.emailStatus == 'true' || this.emailStatus == 'false') {
          this.emailAlert = true;
        }
        if (this.emailStatus != null && response.routerLink == '/home') {
          sessionStorage.removeItem('emailStatus');
        }
        this.breadCrumbService.setBreadCrumbs(response);
        this.breadCrumbs = this.breadCrumbService.getBreadCrumbs();
        if (this.breadCrumbs.length > 0) {
          if (this.breadCrumbs[0].label != 'Home') {
            let home: BreadCrumbModel = new BreadCrumbModel();
            home.label = 'Home';
            home.routerLink = '/home';
            this.breadCrumbs.unshift(home);
          }
        }
        this.isBreadCrumbAvailable = true;
      } else {
        this.isBreadCrumbAvailable = false;
      }
    });
  }
  itemClick(event, breadCrumbs: BreadCrumbModel, rowIndex) {

    this.chipsService.setChips(undefined);

    if (breadCrumbs.label=='Home') 
         this.breadCrumbService.setCurrentBreadCrumb(undefined);

    event.preventDefault();
    this.breadCrumbService.removeSessionBreadCrumbProperty(rowIndex);
    if (breadCrumbs.routerLink === '/enrollmentTool') {
      sessionStorage.removeItem('enrollmentSelectedDetails');
    } else if (breadCrumbs.routerLink === '/productselection') {
      sessionStorage.removeItem('savedSelectedDetails');
    }
    this.router.navigate([breadCrumbs.routerLink]);
  }
}
